// Src
import { AlertColor } from '@mui/material';
import { createAction, createSlice } from '@reduxjs/toolkit';

// Types
type SnackBarMessage = {
    id: number;
    content: string;
    type: AlertColor;
};

type SnackBarState = {
    messages: SnackBarMessage[];
    lastId: number;
};

type AddMessagePayload = {
    content: string;
    type: AlertColor;
};

const snackBarActionTypes = {
    ADD_SNACKBAR: 'snackbar/add_snackbar',
    REMOVE_SNACKBAR: 'snackbar/remove_snackbar',
};

export const addMessageAction = createAction<AddMessagePayload>(snackBarActionTypes.ADD_SNACKBAR);
export const removeMessageAction = createAction<number>(snackBarActionTypes.REMOVE_SNACKBAR);

const initialState: SnackBarState = {
    messages: [],
    lastId: 0,
};

const authenticationSlice = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(addMessageAction, (state, action) => {
            const nextId = state.lastId + 1;
            state.messages.push({
                id: state.lastId + 1,
                content: action.payload.content,
                type: action.payload.type,
            });
            state.lastId = nextId;
        });

        builder.addCase(removeMessageAction, (state, action) => {
            state.messages = state.messages.filter((i) => i.id !== action.payload);
        });
    },
});

export default authenticationSlice.reducer;
